import React, { PureComponent } from 'react';
import { func, string, array, number, shape, bool } from 'prop-types';
import numeral from 'numeral';
import Radium from 'radium';
import { UTButton, UTLabel, WithLoading } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';
import { accountPropTypes } from 'redux/accountHandlers';

import { formatedAccount } from '../../utils';
import AccountDebtTable from '../AccountDebtTable';
import { historyColumns, accountDebtColumns } from '../AccountDebtTable/constants';
import { getAccountDueConcepts, getProcedureHistory, getConceptsByAmount } from '../../registerAccountHelper';
import defaultStyles from '../../styles';

import styles from './styles';

class RegisterAccountHistory extends PureComponent {
  state = { totalDebt: 0 };

  componentDidMount() {
    const { accountTotalDebt, accountDueDebt } = this.props;
    const totalDebt = accountTotalDebt + accountDueDebt;
    this.setState({ totalDebt }, () => this.state.totalDebt <= 0);
  }

  render() {
    const {
      clientNumber,
      bills,
      currentAccountHolderName,
      onProcedureCancel,
      onPayment,
      onGoToDashboard,
      processHistory,
      showOnlyHistory,
      formType,
      accountList
    } = this.props;

    const continueObject = {
      label:
        this.state.totalDebt > 0 ? message('RegisterAccount:payDebt') : message('RegisterAccount:continue'),
      action: this.state.totalDebt > 0 ? () => onPayment(clientNumber) : onGoToDashboard
    };
    return (
      <div style={styles.container}>
        {processHistory && (
          <div style={styles.title}>
            <UTLabel bold large>
              {formType}
            </UTLabel>
            <UTLabel bold large>
              {message('RegisterAccount:procedureNumber', { procedure: processHistory.Id })}
            </UTLabel>
            <UTLabel bold large>
              {processHistory &&
                processHistory.ProcessActivity &&
                processHistory.ProcessActivity.State &&
                processHistory.ProcessActivity.State.Title}
            </UTLabel>
          </div>
        )}
        {!showOnlyHistory && (
          <React.Fragment>
            <div style={defaultStyles.table}>
              <AccountDebtTable
                title={message('RegisterAccount:clientDebt', {
                  supply: clientNumber
                })}
                concepts={getConceptsByAmount(
                  bills.DeudaSuministro,
                  bills.DepositoEnGarantia,
                  bills.DeudaRemanente
                )}
                tableColumns={accountDebtColumns}
              />
              <div style={currentAccountHolderName && styles.table}>
                {currentAccountHolderName && (
                  <AccountDebtTable
                    title={message('RegisterAccount:ownDebt', {
                      holder: currentAccountHolderName
                    })}
                    concepts={getAccountDueConcepts(bills.DeudaCliente)}
                    tableColumns={accountDebtColumns}
                  />
                )}
              </div>
            </div>
            <UTLabel extrabold style={defaultStyles.debtDesc}>
              {message('RegisterAccount:userDebt', {
                debt: numeral(this.state.totalDebt).format('$ 0.[00]')
              })}
            </UTLabel>
            {this.state.totalDebt > 0 && (
              <div style={styles.debtDescContainer}>
                <UTLabel style={defaultStyles.debtDesc}>
                  {message('RegisterAccount:accountDebtDescription')}
                </UTLabel>
              </div>
            )}
          </React.Fragment>
        )}
        {this.state.totalDebt <= 0 && (
          <div style={styles.debtDescContainer}>
            <UTLabel large style={defaultStyles.debtDesc}>
              {message(`RegisterAccount:finishedProcedureWithNIS`, {
                clientNumber: formatedAccount(clientNumber, accountList)
              })}
            </UTLabel>
          </div>
        )}
        <div style={styles.buttonsContainer}>
          {this.state.totalDebt > 0 && !showOnlyHistory && (
            <UTButton secondary style={defaultStyles.continueButton} onPress={onProcedureCancel}>
              {message('RegisterAccount:cancel')}
            </UTButton>
          )}
          <UTButton style={defaultStyles.continueButton} onPress={continueObject.action}>
            {continueObject.label}
          </UTButton>
        </div>

        <div style={defaultStyles.table}>
          <AccountDebtTable
            title={message('AccountHolderChange:procedureHistory')}
            concepts={getProcedureHistory(processHistory)}
            tableColumns={historyColumns}
          />
        </div>
      </div>
    );
  }
}

RegisterAccountHistory.propTypes = {
  clientNumber: string,
  bills: array, // eslint-disable-line
  currentAccountHolderName: string,
  accountTotalDebt: number,
  onGoToDashboard: func,
  accountDueDebt: number,
  onProcedureCancel: func,
  onPayment: func,
  showOnlyHistory: bool,
  formType: string,
  accountList: accountPropTypes,
  processHistory: shape({})
};

export default WithLoading(props => props.loading)(Radium(RegisterAccountHistory));
